<!--
  画面名： -
  画面概要：食材登録用モーダル
  備考：-
-->

<template>
  <v-dialog content-class="foodModalWrapper" v-model="isFoodModal" max-width="1400px" class="white" style="background-color:#FFF">
    <div class="overflowWrapper">
      <div class="wrapper">
          <!-- 食材登録フォーム -->
        <FoodRegistrationFormModal
          v-if="isLoading"
          :isPlan="isPlan"
          :isOperation="isOperation"
          @showDialog="showDialog"
          @confirm="foodSend"
          ref="foodRegistrationFormModal"
        />
      </div>
    </div>
      <v-card-actions class="mt-5">
        <v-spacer />
        <!-- 保存ボタン -->
        <v-btn color="blue darken-1" flat @click="dataValidate">{{$language.LabelSave}}</v-btn>
        <!-- 閉じるボタン -->
        <v-btn color="blue darken-1" flat @click="closeDialog">{{$language.LabelClose}}</v-btn>
      </v-card-actions>
    <!-- 保存ダイアログ -->
    <SaveDialog
      ref="refSaveDialog"
      @set="closeDialog"
    />
  </v-dialog>
</template>

<script>
// 食材登録フォーム
import FoodRegistrationFormModal from '@/components/parts/common/FoodRegistrationFormModal'
// 保存用モーダル
import SaveDialog from '@/components/parts/common/SaveDialog'

export default {
  // 使用コンポーネント
  components: {
    // 食材登録フォーム
    FoodRegistrationFormModal,
    // 保存ダイアログ
    SaveDialog

  },
  props: {
    // 計画策定からの判定
    isPlan: { type: Boolean, default: false },
    // オペレーションからの判定
    isOperation: { type: Boolean, default: false }
  },
  data () {
    return {
      // ダイアログの状態を格納
      isFoodModal: false,
      isLoading: false
    }
  },
  // 処理を定義
  methods: {
    // 食材登録フォーム表示
    loadDialog () {
      this.isLoading = true
    },
    // ダイアログ表示
    showDialog () {
      this.isFoodModal = true
    },
    // ダイアログ非表示
    closeDialog () {
      this.isFoodModal = false
      this.isLoading = false
      this.$emit('send')
    },
    // 食材追加処理のバリデーション
    dataValidate () {
      this.$refs.foodRegistrationFormModal.validate()
    },
    // 食材データをDBに保存
    foodSend (foodData) {
      // コールバック関数用にthisを変数に格納
      let self = this
      function callbackFoodSend (response) {
        // プログレスバーの非表示
        self.$store.dispatch('setIsLoading', false)
        self.$refs.refSaveDialog.openDialog()
      }
      foodData.callback = callbackFoodSend
      if (this.isPlan) {
        // 事業者DBに食材データを保存
        this.$store.dispatch('managementFunction/actionInsertFoodData', foodData)
      } else {
        // 雛形としての食材を保存
        this.$store.dispatch('systemConfig/actionInsertFoodData', foodData)
      }
    }

  }
}
</script>
<!-- style読み込み -->
<style lang="scss" scoped>
  @import '@/assets/scss/managementFunction/setting.scss';
</style>
